import React, { useState, useEffect } from "react";
import "./CSS/HelpSupport.css";
import Success from "../Assets/success_gif.gif";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  check_vaild_save,
  combiled_form_data,
  handleError,
  empty_form,
  formatDateStringdot,
  handleSuccess,
} from "../CommonJquery/CommonJquery.js";
import {
  server_post_data,
  ticket_view_detail,
  reply_ticket,
} from "../ServiceConnection/serviceconnection.js";

function ReplyToTicket({ setTicketTabs, ticketId, setTicketId }) {
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [ticketBody, setTicketBody] = useState("");

  const [ticketConversation, setTicketConversation] = useState([]);
  const [priority_status, setpriority_status] = useState("");
  const [ticketList, setTicketList] = useState([]);
  const [TicketListDetails, setTicketListDetails] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    getAllTickets();
  }, []);

  const getAllTickets = async () => {
    setShowLoaderAdmin(true);
    let formdata = new FormData();
    formdata.append("ticket_id", ticketId);
    await server_post_data(ticket_view_detail, formdata)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          setTicketList(final_data.ticket_view[0]);
          setpriority_status(final_data.ticket_view[0].cus_prority);
          setTicketListDetails(final_data.ticket_view_details);
        }
      })
      .catch((error) => {
        console.log(error);
        setShowLoaderAdmin(false);
      });
  };

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);

    if (vaild_data) {
      setShowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, null);
      fd_from.append("ticket_id", ticketId);
      fd_from.append("staff_customer", "VENDOR");
      fd_from.append("subject", ticketList.cus_message);
      fd_from.append("cus_reply", ticketBody);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          setShowLoaderAdmin(false);
          let data = Response.message.split("~@~");
          const final_data = JSON.parse(data[1]);
          if (parseInt(data[0]) === 1) {
            handleError(final_data.message);
          } else {
            getAllTickets();
            setTicketBody("");
            handleSuccess(final_data.message);
            empty_form(form_data);
          }
        })
        .catch((error) => {
          console.log(error);
          setShowLoaderAdmin(false);
        });
    }
  };

  const handleReviewClose = () => {
    setTicketTabs("Tickets");
    setTicketId(0);
  };

  return (
    <div className="dashboard">
      {/* {ShowLoaderAdmin && <Loader />} */}

      <div className="dashboard_container">
        <div className="page_content">
          <div className="d-flex gap-1 mb-3">
            <button
              className="text-secondary-light d-flex me-8"
              onClick={handleReviewClose}
            >
              <Icon
                icon="mingcute:arrow-left-line"
                className="icon fs-3 line-height-1"
              />
            </button>
            <h6>Back To Tickets</h6>
          </div>
          <div className="page_content_container">
            <div className="page_body">
              <div className="create_staffRights container-lg">
                <div className="Suppotr_wrapper gmb-premium">
                  <div className="newticket-container">
                    <div className="ticketReplyDiv" key={ticketList.ticket_id}>
                      <div className="ticketsListItemHead">
                        <div className="ticketsListItemHeadLeft">
                          {/* <div className="NewTicket"></div> */}
                          <p>#TCK-{ticketList.ticket_id}</p>
                        </div>
                        <div className="ticketsListItemHeadRight">
                          <div className="ticketTime">
                            <p>
                              Posted on{" "}
                              {formatDateStringdot(ticketList.entry_date)}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="ticketDetails">
                        <div className="ticketDetailsContainer">
                          {/* {idx === 0 && <h6>{ticketList.cus_message}</h6>}
                          {idx > 0 && <p>{ticketList.cus_message}</p>} */}
                          <h6>{ticketList.cus_message}</h6>
                        </div>
                      </div>
                    </div>
                    {TicketListDetails &&
                      TicketListDetails.length > 0 &&
                      TicketListDetails.map((ticket, idx) => {
                        return (
                          <div
                            className="ticketReplyDiv"
                            key={ticket.ticket_id}
                          >
                            <div className="ticketsListItemHead">
                              <div className="ticketsListItemHeadLeft">
                                {/* <div className="NewTicket"></div> */}
                                <p>#TCK-{ticketList.ticket_id}</p>
                              </div>
                              <div className="ticketsListItemHeadRight">
                                <div className="ticketTime">
                                  <p>
                                    Posted on{" "}
                                    {formatDateStringdot(ticket.entry_date)}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="ticketDetails">
                              <div className="ticketDetailsContainer">
                                {/* {idx === 0 && <h6>{ticket.cus_message}</h6>} */}
                                {/* {idx > 0 && <p>{ticket.cus_message}</p>} */}
                                <p
                                  style={{
                                    color:
                                      ticket.staff_customer === "STAFF"
                                        ? "var(--primary-500)"
                                        : "",
                                  }}
                                  className="fontSixe"
                                >
                                  {ticket.cus_reply}
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    {ticketList.ticket_category !== "Resolved" && (
                      <>
                        <form id="createRightsForm">
                          <div className="newticket_head newticket_head2">
                            <h6>Reply To Ticket</h6>
                          </div>
                          <div className="newTicketform">
                            <div className="form-row" style={{ padding: "0" }}>
                              <label>Ticket Body</label>
                              <br />
                              <textarea
                                rows="7"
                                value={ticketBody}
                                id="ticket_body"
                                name="ticket_body"
                                className="priorityBtn trio_mandatory form-control"
                                onChange={(e) => setTicketBody(e.target.value)}
                              />
                            </div>
                          </div>
                        </form>
                        <div
                          className="newticketSubmitBtn"
                          style={{ padding: "0 12px" }}
                        >
                          <button
                            onClick={() =>
                              handleSaveChangesdynamic(
                                "createRightsForm",
                                reply_ticket,
                              )
                            }
                          >
                            Reply
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        id="myModal"
        show={showModal}
        onHide={closeModal}
        centered
        backdrop="static"
      >
        <Modal.Body className="modal_body">
          <div className="success_img d-flex justify-content-center">
            <img src={Success} alt="icon" />
          </div>
          <p>
            Your reply has been send successfully. Click on the button below to
            see your tickets.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Link to="/Help">
            <div className="btn go_to_login">View Tickets</div>
          </Link>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ReplyToTicket;
